module.exports = __webpack_public_path__ + "img/line.79b35b69.svg";